<template>
  <div style="background-color: #C4A57F" class="layout-topbar shadow-4">
    <div style="background-color: #C4A57F" class="layout-topbar-left">
      <a class="icon-overlay p-ripple back-class" style="" @click="openSidebarApps()" v-ripple>
        <DotsGrid :size="14 + parseInt(scale)"></DotsGrid>
      </a>
      <router-link class="layout-topbar-logo" style="width: 15rem !important;" :to="{'name': 'main_page', params: { locale: getCurrentI18n() }}">
        <img id="logo" src="/layout/images/logomua.png" alt="ultima-layout" style="height: 3.55rem">
        <div style="font-weight: 400; line-height: 1.1;" class="ml-2" v-html="$t('title')"></div>
      </router-link>

      <a style="left: 20rem;" class="layout-menu-button shadow-6 p-ripple" @click="onMenuButtonClick($event)" v-ripple>
        <i class="pi pi-chevron-right"></i>
      </a>

      <a class="layout-topbar-mobile-button p-ripple" @click="onTopbarMobileButtonClick($event)" v-ripple>
        <i class="pi pi-ellipsis-v fs-large"></i>
      </a>
    </div>

    <div class="layout-topbar-right" :style="{'top: 7rem; height: calc(100% - 7rem);': mobileTopbarActive}"
         :class="{'layout-topbar-mobile-active': mobileTopbarActive}">
      <div v-if="!isWrapped" class="layout-topbar-actions-left">
      </div>

      <div class="layout-topbar-actions-right">
        <ul class="layout-topbar-items">

          <li class="layout-topbar-item app">
            <a class="layout-topbar-action rounded-circle p-ripple" style="min-width: 2.2rem;" @click="openSidebarNotification()"
               v-ripple>
              <span class="p-overlay-badge">
                <i class="pi pi-bell fs-large"></i>
              </span>
            </a>


          </li>
          <li class="layout-topbar-item app">
            <a class="layout-topbar-action rounded-circle p-ripple" style="min-width: 2.2rem;" @click="openSidebar()"
               v-ripple>
              <span class="p-overlay-badge">
                <i class="pi pi-cog fs-large"></i>
              </span>
            </a>


          </li>


          <!--          <AppChangeLocale></AppChangeLocale>-->

<!--          <li class="layout-topbar-item app">-->
<!--            <a class="layout-topbar-action rounded-circle p-ripple" @click="onTopbarItemClick($event, 'apps')" v-ripple>-->
<!--              <i class="pi pi-th-large fs-large"></i>-->
<!--            </a>-->

<!--            <transition name="layout-topbar-action-panel">-->
<!--              <div v-show="activeTopbarItem === 'apps'">-->
<!--                <div class="grid grid-nogutter layout-topbar-action-panel shadow-6 px-2"-->
<!--                     style="border-radius: 0px 0px 10px 10px; "-->
<!--                >-->
<!--                  <div v-for="item in topbar_items" :key="item.name + 'topbar'"-->
<!--                       style="border-radius: 10px; padding: 0rem;"-->
<!--                       class="layout-topbar-action-item col-4">-->
<!--                    <a class="flex align-items-center flex-column text-color" v-ripple>-->
<!--                    <span class="p-3 shadow-2 mb-3 inline-block surface-card" style="border-radius: 10px">-->
<!--                <img style="width: 4rem" :src="'/layout/images/smart/'+item.icon+'.png'"-->
<!--                     alt="">-->
<!--            </span>-->

<!--                      <span class="text-center avoid-page-break">{{ $t(item.name) }}</span>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </transition>-->
<!--          </li>-->

          <li class="layout-topbar-item notifications">
            <a style="padding: 0"
               class="layout-topbar-action flex flex-row justify-content-center align-items-center rounded-circle p-ripple"
               @click="openSidebarUser()" v-ripple>
              <Avatar :image="user.avatar_src" shape="circle"/>

            </a>


          </li>
        </ul>
      </div>
    </div>
  </div>
  <UserSettingsSidebar ref="user_settings"></UserSettingsSidebar>
  <UserSidebar ref="user"></UserSidebar>
  <NotificationSidebar ref="notification"></NotificationSidebar>
  <AppMenuSidebar ref="app"></AppMenuSidebar>
</template>

<script>
// import AppSubmenu from './AppSubmenu';
import {getCurrentI18n} from "@/locales/i18n";

// import AppChangeLocale from "@/AppChangeLocale.vue";
import UserSettingsSidebar from "@/components/UserSettingsSidebar.vue"
import UserSidebar from "@/components/UserSidebar.vue"
import NotificationSidebar from "@/components/NotificationSidebar.vue"
import AppMenuSidebar from "@/components/AppMenuSidebar.vue"
import store from "@/store";
import DotsGrid from 'vue-material-design-icons/DotsGrid.vue';
export default {
  components: {
    // 'AppChangeLocale': AppChangeLocale,
    'UserSettingsSidebar': UserSettingsSidebar,
    'NotificationSidebar': NotificationSidebar,
    'AppMenuSidebar': AppMenuSidebar,
    'UserSidebar': UserSidebar,
    'DotsGrid': DotsGrid,
    // 'AppSubmenu': AppSubmenu
    },
  emits: ['menubutton-click', 'topbar-menubutton-click', 'topbaritem-click', 'rightpanel-button-click', 'topbar-mobileactive', 'search-click', 'search-toggle'],
  data() {
    return {
      searchText: '',
      open_modal: false,
      open_modal_user: false,
      open_modal_app: false,
      open_modal_notif: false,
      windowWidth: window.innerWidth,
      topbar_items: [
        {'name': 'document', 'icon': 'document'},
        {'name': 'outlook', 'icon': 'outlook'},
        {'name': 'elibrary', 'icon': 'elibrary'},
        {'name': 'platonus', 'icon': 'platonus'},
        {'name': 'moodle', 'icon': 'moodle'},
        {'name': 'proktoring', 'icon': 'proktoring'},
      ],
      languages: [],

      items: [
        {
          is_main: true,
        },
        {
          label: 'change_password',
          icon: 'pi pi-times',
          to: {name: 'change_password'}
        },
      ]
    }
  },
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    topbarMenuActive: {
      type: Boolean,
      default: false
    },
    activeTopbarItem: String,
    mobileTopbarActive: Boolean,
    searchActive: Boolean
  },
  methods: {
    getCurrentI18n,
    launchFilePicker() {
      this.$refs.file.click();
    },
    onSearchContainerClick(event) {
      this.$emit("search-click", event);
    },
    openSidebar() {
      this.open_modal = true
      this.$refs.user_settings.openModal();
    },
    openSidebarUser() {
      this.open_modal_user = true
      this.$refs.user.openModal();
    },
    openSidebarNotification() {
      this.open_modal_notif = true
      this.$refs.notification.openModal();
    },
    openSidebarApps() {
      this.open_modal_app = true
      this.$refs.app.openModal();
    },
    changeSearchActive(event) {
      this.$emit('search-toggle', event);
    },
    onMenuButtonClick(event) {
      this.$emit('menubutton-click', event);
    },
    onTopbarMenuButtonClick(event) {
      this.$emit('topbar-menubutton-click', event);
    },
    onTopbarItemClick(event, item) {
      if (item === 'search') {
        this.$emit('search-toggle', event);
      }

      this.$emit('topbaritem-click', {originalEvent: event, item: item});
    },
    onTopbarMobileButtonClick(event) {
      this.$emit('topbar-mobileactive', event);
    },
    onRightPanelButtonClick(event) {
      this.$emit('rightpanel-button-click', event);
    },
    onSearchKeydown(event) {
      if (event.keyCode == 13) {
        this.$emit('search-toggle', event);
      }
    },
    onEnter() {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.$el.focus();
      }
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  computed: {
    scale() {
      return store.state.scale
    },
    user() {
      return store.state.user.data
    },
    isMobile() {
      return this.windowWidth <= 640;
    },
    isWrapped() {
      return this.windowWidth <= 991;
    },
    topbarItemsClass() {
      return ['topbar-items animated fadeInDown', {
        'topbar-items-visible': this.topbarMenuActive
      }];
    },
    isRTL() {
      return this.$appState.RTL;
    }
  }
}
</script>
<style>

.icon-overlay {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1.2rem;
  border-radius: 1%;
  height: 3.2rem;
  cursor: pointer;
  height: 100%;
}
.back-class:not(:hover){
background-color:var(--amber-600)
}
</style>
